import cx from "classnames";
import { useTranslation } from "react-i18next";
import type { NavigationMode } from "@/actionManager/actionManager";
import MouseSvg from "../../../icons/mouse.svg?react";
import TrackpadSvg from "../../../icons/trackpad.svg?react";
import styles from "./NavigationSelectWindow.module.css";

type NavigationWindowLayoutProps = {
    mode: NavigationMode;
    onSelect: (mode: NavigationMode) => void;
    onSave: () => void;
};

export const NavigationWindowLayout = ({ mode, onSelect, onSave }: NavigationWindowLayoutProps) => {
    const { t } = useTranslation();

    return (
        <div className={styles.navigationSelectWindow}>
            <div className={styles.navigationSelectWindowAbout}>{t("navigation.title")}</div>
            <div className={styles.navigationSelectWindowMode}>
                <div
                    className={cx(styles.navigationSelectWindowModeItem, {
                        [styles.navigationSelectWindowModeItemSelected]: mode === "mouse",
                    })}
                    onClick={() => onSelect("mouse")}
                >
                    <div className={styles.navigationSelectWindowModeItemIcon}>
                        <MouseSvg />
                    </div>
                    <div className={styles.navigationSelectWindowModeItemName}>
                        {t("navigation.mouse")}
                    </div>
                </div>
                <div
                    className={cx(styles.navigationSelectWindowModeItem, {
                        [styles.navigationSelectWindowModeItemSelected]: mode === "trackpad",
                    })}
                    onClick={() => onSelect("trackpad")}
                >
                    <div className={styles.navigationSelectWindowModeItemIcon}>
                        <TrackpadSvg />
                    </div>
                    <div className={styles.navigationSelectWindowModeItemName}>
                        {t("navigation.trackpad")}
                    </div>
                </div>
            </div>
            <div className={styles.navigationSelectWindowDescription}>
                {t("navigation.description")}
            </div>
            <div className={styles.navigationSelectWindowActions}>
                <div
                    className={cx(
                        styles.navigationSelectWindowActionsItem,
                        styles.navigationSelectWindowActionsItemAction,
                    )}
                    onClick={onSave}
                >
                    {t("navigation.done")}
                </div>
            </div>
        </div>
    );
};
